module.exports = __webpack_public_path__ + "static/img/3-6.3a4243c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-6.jpg
// module id = W8bZ
// module chunks = 25